import api from 'api/api'
import { toast } from 'react-toastify'

export const GET_UNIT_MEASURES_BY_PRODUCT = '[UNIT MEASURES] GET UNIT MEASURES BY PRODUCT ID'
export const SAVE_PRODUCT_UNIT_MEASURE = '[UNIT MEASURES] SAVE PRODUCT UNIT MEASURE'
export const REMOVE_PRODUCT_UNIT_MEASURE = '[UNIT MEASURES] REMOVE PRODUCT UNIT MEASURE'

export function getUnitMeasuresByProductId(productId, sucursalId) {
  const request = api.get(`/product-unit-measures/by-product-id/${productId}`, { params: { sucursalId } })
  return (dispatch) => {
    dispatch({ type: GET_UNIT_MEASURES_BY_PRODUCT, payload: { loading: true } })
    request.then((response) => {

      dispatch({ type: GET_UNIT_MEASURES_BY_PRODUCT, payload: { loading: false, data: response.data.data } })
    }).catch((error) => {
      dispatch({ type: GET_UNIT_MEASURES_BY_PRODUCT, payload: { loading: false } })
      toast.error("Error inesperado, no se pudo obtener las unidades de medida del producto")
      console.log(GET_UNIT_MEASURES_BY_PRODUCT, error)
    })
  }
}

export function saveProductUnitMeasure(data) {
  const request = api.post(`/product-unit-measures/save`, data)
  return (dispatch) => {
    dispatch({ type: SAVE_PRODUCT_UNIT_MEASURE, payload: { saving_id: data.unidad_medida_id } })
    request.then((response) => {

      if (Number(response.data.status) !== 200) {
        dispatch({ type: SAVE_PRODUCT_UNIT_MEASURE, payload: { saving_id: data.unidad_medida_id } })
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SAVE_PRODUCT_UNIT_MEASURE, payload: { saved_id: data.unidad_medida_id } })
      dispatch({
        type: SAVE_PRODUCT_UNIT_MEASURE, payload: {
          saved_id: data.unidad_medida_id,
          saving_id: data.unidad_medida_id,
          data: response.data.data
        }
      })
      toast.success(response.data.message)
    }).catch((error) => {
      dispatch({ type: SAVE_PRODUCT_UNIT_MEASURE, payload: { saving_id: data.unidad_medida_id } })
      toast.error("Error inesperado, no se pudo guardar la unidad de medida")
      console.log(SAVE_PRODUCT_UNIT_MEASURE, error)
    })
  }
}

export function removeProductUnitMeasure(params = { unitMeasureId: 0, productId: 0 }) {
  const request = api.delete(`/product-unit-measures/remove`, { params })
  return (dispatch) => {
    dispatch({ type: REMOVE_PRODUCT_UNIT_MEASURE, payload: { removing_id: params.unitMeasureId } })
    request.then((response) => {

      if (Number(response.data.status) !== 200) {
        dispatch({ type: REMOVE_PRODUCT_UNIT_MEASURE, payload: { removing_id: params.unitMeasureId } })
        toast.error(response.data.message)
        return
      }
      dispatch({ type: REMOVE_PRODUCT_UNIT_MEASURE, payload: { removing_id: params.unitMeasureId, removed_id: params.unitMeasureId } })
      toast.success(response.data.message)
    }).catch((error) => {
      dispatch({ type: REMOVE_PRODUCT_UNIT_MEASURE, payload: { removing_id: params.unitMeasureId } })
      toast.error("Error inesperado, no se pudo remover la unidad de medida")
      console.log(REMOVE_PRODUCT_UNIT_MEASURE, error)
    })
  }
}
